// Fine Print – theme interactions

document.addEventListener('DOMContentLoaded', () => {

  // Mobile nav toggle
  const hamburger = document.querySelector('.fp-hamburger');
  const mobileMenu = document.querySelector('.fp-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open);
    });
  }

  // Collection page: tag filters
  const filterBtns = document.querySelectorAll('.fp-filter-btn');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const tag = btn.dataset.tag;
      const url = new URL(window.location.href);
      if (tag === 'all') {
        url.searchParams.delete('filter_tag');
      } else {
        url.searchParams.set('filter_tag', tag);
      }
      window.location.href = url.toString();
    });
  });

 document.querySelectorAll('.fp-color-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const selectedColor = btn.dataset.color;

      // Update color label
      const colorLabel = document.getElementById('fp-selected-color');
      if (colorLabel) colorLabel.textContent = selectedColor;

      document.querySelectorAll('.fp-color-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const thumbs = document.querySelectorAll('.fp-pdp-thumb');
      let firstVisible = null;
      thumbs.forEach(thumb => {
        const thumbColor = thumb.dataset.color;
        if (!thumbColor) {
          thumb.style.display = '';
          return;
        }
        const match = thumbColor.toLowerCase() === selectedColor.toLowerCase();
        thumb.style.display = match ? '' : 'none';
        if (match && !firstVisible) firstVisible = thumb;
      });

      thumbs.forEach(t => t.classList.remove('active'));
      if (firstVisible) {
        firstVisible.classList.add('active');
        const newSrc = firstVisible.dataset.imgSrc;
        if (newSrc) document.getElementById('fp-main-img').src = newSrc;
      }
    });
  });

  // On load: filter thumbs to match the first active color
  const initialColor = document.querySelector('.fp-color-btn.active')?.dataset.color;
  if (initialColor) {
    document.querySelectorAll('.fp-pdp-thumb').forEach(thumb => {
      const thumbColor = thumb.dataset.color;
      if (!thumbColor) {
        thumb.style.display = '';
        return;
      }
      const match = thumbColor.toLowerCase() === initialColor.toLowerCase();
      thumb.style.display = match ? '' : 'none';
    });
  }

  // PDP: size selection
  const sizeBtns = document.querySelectorAll('.fp-size-btn');
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      updateVariant();
    });
  });

  // PDP: quantity controls
  const qtyVal = document.querySelector('.fp-qty-val');
  const qtyDown = document.querySelector('.fp-qty-down');
  const qtyUp = document.querySelector('.fp-qty-up');
  if (qtyVal && qtyDown && qtyUp) {
    qtyDown.addEventListener('click', () => {
      const v = parseInt(qtyVal.value, 10);
      if (v > 1) qtyVal.value = v - 1;
    });
    qtyUp.addEventListener('click', () => {
      qtyVal.value = parseInt(qtyVal.value, 10) + 1;
    });
  }

  // PDP: tab switching
  const tabBtns = document.querySelectorAll('.fp-tab-btn');
  const tabPanels = document.querySelectorAll('.fp-tab-panel');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.hidden = true);
      btn.classList.add('active');
      const target = document.querySelector(`.fp-tab-panel[data-tab="${btn.dataset.tab}"]`);
      if (target) target.hidden = false;
    });
  });

  // PDP: variant selector (size drives the hidden variant input)
  function updateVariant() {
    const activeSize = document.querySelector('.fp-size-btn.active');
    if (!activeSize) return;
    const variantId = activeSize.dataset.variantId;
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantId) {
      variantInput.value = variantId;
    }
  }

  // Image thumbnail switching
  const thumbs = document.querySelectorAll('.fp-pdp-thumb');
  const mainImg = document.querySelector('.fp-pdp-main-img img');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.dataset.imgSrc;
      if (mainImg && src) mainImg.src = src;
    });
  });

});